import { format } from "date-fns"
export const formatDateWithTime = (date) => {
    return date ? format(new Date(date), "MMMM dd, yyyy, h:mm a") : ""
}

export const formatDate = (date) => {

    return date ? format(new Date(date), "dd MMM,yyyy") : ""
}